export const loggly_payment_type = {
  ADDON: 'ADDON BOUGHT',
  ADC_RECHARGE: 'ADC RECHARGE',
  CREDITS: 'CREDITS BOUGHT',
  CREATE_CANDIDATE: 'CANDIDATE ADDED',
  PACKAGE_BOUGHT: 'PACKAGE BOUGHT',
  ORDER: 'ORDER'
};

export const IdentityArr = {
  PAN: 'PAN card',
  DL: 'Driving license',
  VOTER_ID: 'Voter ID',
  AADHAAR: 'Aadhaar',
  PASSPORT: 'Passport'
};

export const AddressArr = {
  CURRENT: 'Current address',
  PERMANENT: 'Permanent address',
  ANY_1: 'Any 1 (PERMANENT,CURRENT)',
  ANY_2: '(PERMANENT,CURRENT)'
};

export const AddressConstants = {
  ANY_1: 'ANY_1',
  ANY_2: 'ANY_2',
  PERMANENT: 'PERMANENT',
  CURRENT: 'CURRENT'
};

export const EducationArr = {
  10: '10th grade',
  12: '12th grade / Diploma',
  UG: 'Undergraduate degree',
  UNDERGRAD: 'Undergraduate degree',
  PG: 'Postgraduate degree',
  POSTGRAD: 'Postgraduate degree',
  PHD: 'PhD',
  PHD: 'PhD'
};
export const DRUG_CHECK_TEXT = {
  '5_PANEL': '5 Panel',
  '7_PANEL': '7 Panel',
  '10_PANEL': '10 Panel'
};
export const TDS_OPTIONS = [
  { value: 'NONE', label: 'None', disable: false },
  { value: '2', label: '2%', disable: false },
  { value: '10', label: '10%', disable: false }
];

export const PACKAGE_UNIT_INDICATION = {
  NILL: 'NILL', // CRITICAL
  LOW: 'LOW',
  SUFFICIENT: 'SUFFICIENT'
};

export const WALLET_BALLANCE_INDICATION = {
  NILL: 'NILL', // CRITICAL
  LOW: 'LOW',
  SUFFICIENT: 'SUFFICIENT'
};

export const SUPPORTED_MIME_TYPE = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  pdf: "application/pdf",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv"
}
export const PACKAGE_UNIT_INDICATION_FACTOR = 0.2;
